<template>
  <!-- <div class="base-combobox" :class="{ 'dropdown-hidden': hideOptions }"> -->
    <!-- <b-field :label="label" /> -->
    <b-field
      :label="label"
      :horizontal="horizontal"
      class="base-combobox"
      :class="{ 'dropdown-hidden': hideOptions }"
    >
      <b-autocomplete
        v-model="value_"
        :data="optionsFiltered"
        :field="labelKey"
        :custom-formatter="customFormatter"
        icon="search"
        expanded
        :open-on-focus="openOnFocus"
        check-infinite-scroll
        :size="`${small ? 'is-small' : ''}`"
        :loading="fetching || loading"
        :disabled="fetching || loading || disabled"
        @select="onSelect"
        @infinite-scroll="onInfiniteScroll"
        ref="autocomplete"
      >
        <template slot="header">
          <slot name="header" :value="value_">
            <a @click="() => addNew(value_)" v-if="allowNew"><span> Add new... </span></a>
          </slot>
        </template>
        <template slot="empty">
          <slot name="empty">
            No results found
          </slot>
        </template>
      </b-autocomplete>
      <slot name="control" :value="value_" />
    </b-field>
    <!-- <slot name="list" :options="options" :optionsFiltered="optionsFiltered" /> -->
  <!-- </div> -->
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    service: {
      type: Function,
      required: true
    },
    fetchFunc: {
      type: String,
      required: true
    },
    fetchParams: {
      type: Object,
      default: () => {}
    },
    createService: {
      type: Function,
    },
    createFunc: {
      type: String,
    },
    createParams: {
      type: Object,
      default: () => {}
    },
    denormalize: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String
    },
    labelKey: {
      type: String,
      default: "name"
    },
    perScroll: {
      type: Number,
      default: 10
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openOnFocus: {
      type: Boolean,
      default: true
    },
    hideOptions: {
      type: Boolean,
      default: false
    },
    fetchOnInit: {
      type: Boolean,
      default: false
    },
    allowNew: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false,
    },
    customFormatter: {
      type: Function,
    },
  },
  data: () => ({
    value_: "",
    options: [],
    currentPage: 1,
    totalPages: 1,
    fetching: false
  }),
  computed: {
    optionsFiltered() {
      return this.options.filter(
        option => {
          const label = this.customFormatter
            ? this.customFormatter(option)
            : this.getObjectValue(option, this.labelKey);
          return (
            label.toString().toLowerCase().indexOf(this.value_.toLowerCase()) >= 0
          );
      });
    },
    // check infinite scroll autocomplete prop is not updated in realtime
    // so infinite scroll is check on fetch
    // enabled only if options are not filtered
    infiniteScroll() {
      return !this.value_;
    }
  },
  created() {
    if (this.fetchOnInit) {
      this.fetchOptions();
    }
    this.value_ = this.value;
  },
  watch: {
    value(value) {
      this.value_ = value;
    },
    value_(value) {
      this.$emit("update:value", value);
    }
  },
  methods: {
    async fetchOptions(page = 1, append = true) {
      if (page > this.totalPages) return;

      this.fetching = true;

      try {

        const params = Object.assign({}, this.fetchParams, { page: page });
        console.log('params', params)
        console.log('fetchParams', this.fetchParams)
        if (typeof this.fetchParams.per_page === 'undefined') {
            params.per_page = this.perScroll;
        }

        await this.service[this.fetchFunc](params).then(response => {
          const options = this.denormalize
            ? JsonDenormalizer.denormalize(response)
            : response;

          if (append) {
            this.options = [...this.options, ...options];
          } else {
            this.options = options;
          }

          if (response.meta && response.meta.pagination) {
            this.currentPage = response.meta.pagination.current_page;
            this.totalPages = response.meta.pagination.total_pages;
          }
        });
      } catch (err) {}

      this.fetching = false;

      return this.options;
    },
    getObjectValue(obj, path) {
      return path.split(".").reduce((acc, val) => {
        acc = acc[val] || "N/A";
        return acc;
      }, obj);
    },
    onSelect(option) {
      this.$emit("select", option);
    },
    onInfiniteScroll() {
      if (!this.infiniteScroll) return;
      this.fetchOptions(this.currentPage + 1);
    },
    // External methods
    setSelected(value) {
      this.$refs.autocomplete.setSelected(value);
    },
    clear() {
      this.value_ = "";
    },
    focus() {
      this.$refs.autocomplete.focus();
    },
    async addNew(value) {
      // if (!this.options.find(v => v[this.labelKey] == value)) {
      //   this.options.push({ [this.labelKey]: value })
      // }
      this.fetching = true; // Trigger loading
			if ( ! this.options.find(v => v[this.labelKey] == value)) {
        let option = { [this.labelKey]: value };
        if (this.createService && this.createFunc) {
          option = await this.createService[this.createFunc]({
            [this.labelKey]: value,
            ...this.createParams,
          }).then(response => JsonDenormalizer.denormalize(response));
        }
        this.options.push(option);
        this.$emit("add-new", option);
			}
			this.fetching = false;
    },
  },
};
</script>

<style lang="scss">
.base-combobox {
  .autocomplete .dropdown-item.is-disabled {
    opacity: 1;
  }
}
.base-combobox.dropdown-hidden {
  .autocomplete .dropdown-menu {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/BaseCombobox.vue